export const timelineData = [
    {
        id: 1,
        type: "work",
        timelineObj: {
          time: "Jul, 2022 - Present",
          title: "Software Engineer",
          organization: "Merkle",
          description:"Led a transformative year-long initiative with the SFMC-Personalization Accelerator, employing cutting-edge technologies for significant time reductions, while managing diverse client projects, optimizing workflows, crafting extensive sitemaps, and collaborating across industries for tailored and effective solutions."},
      },
  {
    id: 2,
    type: "work",
    timelineObj: {
      time: "Jan, 2022 - Jun, 2022",
      title: "Consultant",
      organization: "Merkle",
      description:
        "Crafted seamless online experiences for renowned sports equipment and cowboy boots brands, optimizing navigation, and driving conversions through strategic enhancements and personalized product recommendations.",
    },
  },
  {
    id: 3,
    type: "work",
    timelineObj: {
      time: "Aug, 2021 - Nov, 2021",
      title: "React Developer",
      organization: "Nav360 Fleet Management Solutions",
      description:
        "Played a key role in the UI development of Nav360’s SaaS solution for rental mobility, utilizing cutting-edge technologies and crafting a seamless user interface to enhance the product’s usability and overall user experience.",
    },
  },
  {
    id: 4,
    type: "school",
    timelineObj: {
      time: "July, 2018 - June 2022",
      title: "B.Tech in Information Technology",
      organization: "Manipal Institute of Technology",
      description: "Graduated with a CGPA of 7.91",
    },
  },
];
